import React, { useState, useEffect } from "react";
import "./EventCreatedModal.css";
import { useNavigate } from "react-router-dom";
import ShareLinkModal from "../../Modals/shareLinkModal/ShareLinkModal";
import InviteTypeSelectorModal from "../../Modals/invieTypeSelector/InviteTypeSelectorModal";

const EventCreatedModal = ({
  visible,
  onClose,
  onShare,
  title = "NimbleBash Created",
  eventData = {},
  description = "Your NimbleBash invite is ready! Share the link with your guests and let the celebration begin!!!🎉🎉🎉🎉🎉",
  imagePath = "/images/successModal.png",
  hideButtons = false,
}) => {
  const navigate = useNavigate();
  const [shareModalVisible, setShareModalVisible] = useState(false);
  const [inviteTypeSelectorVisible, setInviteTypeSelectorVisible] =
    useState(false);
  const [selectedInviteType, setSelectedInviteType] = useState(null);

  const status = eventData?.status || "pending";

  // Lock scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = visible ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [visible]);

  if (!visible) return null;

  const handleEditEvent = () => {
    navigate(`/update-event?eventId=${eventData?._id}`);
  };

  const handleShareButtonPress = () => {
    if (status !== "approved" && status !== "updated") return;
    // Show the invite type selector modal first
    setInviteTypeSelectorVisible(true);
  };

  const handleInviteTypeSelect = (inviteType) => {
    console.log("Selected invite type:", inviteType);
    setSelectedInviteType(inviteType);
    setInviteTypeSelectorVisible(false);
    // Now open the ShareLinkModal with the selected invite type
    setShareModalVisible(true);
  };

  const handleCloseShareModal = () => {
    setShareModalVisible(false);
    setSelectedInviteType(null);
    onClose();
    navigate(`/home/host?reload=${Date.now()}`);
  };

  const handleCloseInviteTypeSelector = () => {
    setInviteTypeSelectorVisible(false);
  };

  // Status-dependent UI text, images, and buttons
  const statusInfo = {
    pending: {
      title: "Event Under Admin Review",
      description:
        "Your event has been submitted successfully and is currently under review by our admin team. You will receive an email notification once it's approved. The share invite link will be available after approval.",
      showShareButton: false,
      showEditButton: false,
      image: "/images/successModal.png",
      buttonText: "Awaiting Admin Approval",
    },
    declined: {
      title: "Event Requires Updates",
      description:
        "Your event was declined. Please check your email for feedback from our admin team. You can edit your event details and resubmit for review.",
      showShareButton: false,
      showEditButton: true,
      image: "/images/declineImage.png",
      buttonText: "Edit Event",
    },
    approved: {
      title: title || "Event Created Successfully",
      description:
        description ||
        "Your event has been approved! You can now share the invite link with your guests.",
      showShareButton: true,
      showEditButton: false,
      image: "/images/approved.png",
      buttonText: "Share Invite Link",
    },
    updated: {
      title: "Event Updated Successfully",
      description:
        "Your event has been updated successfully! You can now share the invite link with your guests.",
      showShareButton: true,
      showEditButton: false,
      image: "/images/approved.png",
      buttonText: "Share Invite Link",
    },
  }[status];

  return (
    <>
      <div className="event-modal-overlay">
        <div className="modal-container slide-up">
          <button className="close-btn" onClick={onClose}>
            ×
          </button>

          <div className="image-wrapper">
            <img src={statusInfo.image} alt="status" className="modal-image" />
          </div>

          <h2 className={`modal-title ${status}`}>{statusInfo.title}</h2>

          <p className="modal-description">{statusInfo.description}</p>

          {!hideButtons && (
            <div className="button-row">
              <button className="ec-close-btn" onClick={onClose}>
                Close
              </button>

              {statusInfo.showShareButton ? (
                <button
                  className="ec-share-btn"
                  onClick={handleShareButtonPress}
                >
                  {statusInfo.buttonText}
                </button>
              ) : statusInfo.showEditButton ? (
                <button className="ec-edit-btn" onClick={handleEditEvent}>
                  {statusInfo.buttonText}
                </button>
              ) : (
                <button className="ec-pending-btn" disabled>
                  {statusInfo.buttonText}
                </button>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Invite Type Selector Modal */}
      <InviteTypeSelectorModal
        visible={inviteTypeSelectorVisible}
        onClose={handleCloseInviteTypeSelector}
        onSelect={handleInviteTypeSelect}
      />

      {/* Share Modal (only shown after invite type is selected) */}
      {(status === "approved" || status === "updated") && (
        <ShareLinkModal
          visible={shareModalVisible}
          onClose={handleCloseShareModal}
          eventData={eventData}
          inviteType={selectedInviteType}
        />
      )}
    </>
  );
};

export default EventCreatedModal;
